import { type DBSchema, type IDBPDatabase, openDB } from 'idb'

export type OutboxStatus = 'queued' | 'sending' | 'failed'

export interface OutboxItem {
  clientMessageId: string
  orgId: string
  conversationId: string
  kind: 'text' | 'media'
  /** Text body, or caption for media. */
  content?: string
  mediaKind?: 'image' | 'audio' | 'video' | 'document'
  fileBlob?: Blob
  mediaUrl?: string
  mediaStorageKey?: string
  fileName?: string
  fileType?: string
  createdAt: string
  status: OutboxStatus
  failureReason?: string | null
}

interface OutboxDB extends DBSchema {
  outbox: {
    key: string
    value: OutboxItem
    indexes: { 'by-conversation': string }
  }
}

let dbPromise: Promise<IDBPDatabase<OutboxDB>> | null = null

function getDB() {
  if (!dbPromise) {
    dbPromise = openDB<OutboxDB>('agrosdr-inbox-outbox', 1, {
      upgrade(db) {
        const store = db.createObjectStore('outbox', {
          keyPath: 'clientMessageId',
        })
        store.createIndex('by-conversation', 'conversationId')
      },
    })
  }
  return dbPromise
}

export async function putOutboxItem(item: OutboxItem): Promise<void> {
  const db = await getDB()
  await db.put('outbox', item)
}

export async function deleteOutboxItem(clientMessageId: string): Promise<void> {
  const db = await getDB()
  await db.delete('outbox', clientMessageId)
}

export async function getAllOutboxItems(): Promise<OutboxItem[]> {
  const db = await getDB()
  return db.getAll('outbox')
}
